import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { StyledLayoutBase } from './StyledLayoutBase.js';

const Layout = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(StyledLayoutBase, _extends({
    ref: forwardedRef,
    bg: "slate0",
    flexDirection: "column",
    position: "relative"
  }, rest), children);
});

export { Layout };
